import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {NetworkInterface} from "@catmodules/models/network-interfaces/types";
import {Restangular} from "ngx-restangular";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs/Observable";

@Injectable()
export class NetworkInterfaceService extends RestHttpService<NetworkInterface> {

  constructor(private store: Store<any>, restService: Restangular) {
    super('project-network-interfaces', restService);
  }

  /**
   * Initiates the process to create a single FeatureUnit through the WebAPI
   * @param {FeatureUnitCreateInfo} item
   * @returns {Observable<any>}
   */
  create(item: NetworkInterface): Observable<any> {
    return this.queryAll()
      .post(item);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/network-interfaces/services/network-interface.service.ts